import {useTranslation} from 'react-i18next'

export const RowHead = () => {
  const {t} = useTranslation()

  return (
    <tr>
      <th>{t('No')}</th>
      <th>Sales Org</th>
      <th>{t('sub-order-provinsi')}</th>
      <th>{t('sub-order-kota')}</th>
      <th>{t('Plant Code')}</th>
      <th>{t('Plant')}</th>
      <th>{t('Sales Group')}</th>
      <th>Status</th>
      <th>{t('kontrak-aksi')}</th>
    </tr>
  )
}
